import { Modal } from "antd";

const ModalComponent = (props) => {
    const { isModalOpen, children, handleCancel, title } = props
    return (
        <Modal
            footer={null}
            title={title}
            open={isModalOpen}
            onCancel={handleCancel}
        >
            {children}
        </Modal>
    );
}

export default ModalComponent;